import * as type from './mutations_types.js';

export default {
    //更新当前页面name
    [type.GET_ROUTE_NAME](states, obj) {
        states.routeName = obj.routeName;
    },

    //更新答题时间(2分钟间隔)
    [type.GET_REMAIN_TIME](states, obj) {
        states.remainTime = obj.remainTime;
    },

    //修改字体大小
    [type.CHANGE_FONT_SIZE](states, obj) {
        states.fontSize = obj.fontSize
    },

    //更新socket收到消息类型
    [type.GET_SOCKET_TYPE](states, obj) {
        states.socketType = obj.socketType
    },

    //更新socket收到消息数据
    [type.GET_SOCKET_DATA](states, obj) {
        states.socketData = obj.socketData
    }
}



// WEBPACK FOOTER //
// ./src/store/anscart/mutations.js